import "twin.macro";

import MainNavigationLink from "./MainNavigationLink";
import { mainNavigationStart, NavigationGroup } from "./navigationData";

type NavigationProps = {
  onNavigate?: () => void;
};

export const Navigation = ({ onNavigate }: NavigationProps) => {
  const mainNavigation: NavigationGroup[] = [mainNavigationStart];

  return (
    <nav tw="flex w-full text-white">
      <ul role="list" tw="flex flex-col w-full lg:gap-y-7 gap-y-5 divide-y">
        {mainNavigation.map((group, index) => (
          <li key={String(group.title) + index}>
            <div tw="text-xs font-semibold leading-6 text-white/70">
              {group.title}
            </div>

            <ul role="list" tw="space-y-1">
              {group.children.map((linkData) => (
                <li key={linkData?.to?.toString()}>
                  <MainNavigationLink
                    {...linkData}
                    onClick={() => onNavigate?.()}
                  />
                </li>
              ))}
            </ul>
          </li>
        ))}
      </ul>
    </nav>
  );
};
